import Vue from 'vue'

import UserSettingService from 'Services/UserSettingService'

const favoriteKey = 'ContextFavorites'

const state = Vue.observable({ favoriteItems: undefined })

export default {
  computed: {
    favoriteItems: {
      get () {
        return state.favoriteItems
      },
      set (value) {
        state.favoriteItems = value
      }
    }
  },

  methods: {
    addFavorite ({ businessId, merchantId }) {
      return this.updateFavoriteItems([...this.favoriteItems, { businessId, merchantId }])
    },

    removeFavorite ({ businessId, merchantId }) {
      return this.updateFavoriteItems(merchantId ? this.favoriteItems.filter(item => item.merchantId !== merchantId) : this.favoriteItems.filter(item => !(item.businessId === businessId && typeof item.merchantId === 'undefined')))
    },

    /**
     * Get favorite items
     *
     * @param {string} key
     */
    getFavoriteItems () {
      return UserSettingService.getUserSettings(favoriteKey, []).then(items => {
        this.favoriteItems = items
      })
    },

    /**
     * Update favorite items
     *
     * @param {Array} value
     */
    updateFavoriteItems (items) {
      return new Promise((resolve, reject) => {
        UserSettingService.saveUserSettings(favoriteKey, items).then(() => {
          this.getFavoriteItems(favoriteKey).then((setting) => resolve(setting))
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
